/*
 * One stacking order for everything that floats over a page (2026-10-18).
 * Overlays used to pick their own z-index (50, 1000, 2000, 3600...), so a
 * dialog could open UNDER the nav bar (Lab's checks sat at 50, the nav at
 * 300). New overlays take a layer from here; the older ones keep their
 * numbers, written down below, until they move onto components/ui/Dialog.
 *
 *   nav bar             300-500   (Layout.js)
 *   drawer              1000/1100 (.hub-drawer in index.css, PointDrawer)
 *   sheet               1200      a camera's edge sheets (Sheet.js), above the drawers
 *   dialog              1500      above any drawer or sheet it opens from
 *   confirm             2000      a confirmation, above the dialog that asked
 *   chat drawer         2500      Layout's chat (components/chat/ChatDrawer.js), above
 *                                 a page's dialog it is opened from (a handoff's Message)
 *   photo viewer        3000-3200 (PhotoGallery, PhotoViewer, PhotoAnnotator)
 *   over the viewer     3300      a dialog opened from a photograph or the live camera
 *   report an issue     3500/3600 (ReportIssueTab, ReportIssueModal)
 *   view-as banner      4000
 */
export const LAYERS = Object.freeze({
  sheet: 1200,
  dialog: 1500,
  confirm: 2000,
  chat: 2500,
  overViewer: 3300,
});
